import React, { useCallback, useState } from "react";

import { useNotificationReceivedListener, useUserActivityCreatedListener } from "app/hooks";
import { Trans } from "app/utils";
import notificationsTypes from "constants/notificationsTypes";


const StoryTrendNotification = ({ currentActivity, onNotificationClicked, questionId }) => {
  const [inactive, setInactive] = useState([]);

  useUserActivityCreatedListener(
    useCallback(
      activity => {
        if ((activity.id === currentActivity?.id && activity.childUserActivities.length > 0)
        || parseInt(questionId, 10) === activity.entity.question?.id) {
          setInactive([activity, ...inactive]);
        }
      },
      [currentActivity, setInactive, inactive, questionId]
    )
  );

  useNotificationReceivedListener(
    useCallback(
      notification => {
        switch (notification.notificationType) {
          case notificationsTypes.FOR_YOU:
          case notificationsTypes.NOT_FOR_YOU:
            if ((notification.entity.id === currentActivity?.id
              && notification.entity.childUserActivities.length > 0)
              || parseInt(questionId, 10) === notification.entity.question?.id) {
              setInactive([notification.entity, ...inactive]);
            }
            break;
          default:
            break;
        }
      },
      [currentActivity, setInactive, inactive, questionId]
    )
  );

  const onClick = useCallback(
    () => {
      onNotificationClicked(inactive);
      setInactive([]);
    },
    [setInactive, onNotificationClicked, inactive]
  );

  return (
    <>
      {inactive.length > 0 && (
        <div className="NewContent box-shadow" onClick={onClick}>
          <p role="alert">
            {
              inactive.length === 1
                ? <Trans>See 1 new activity</Trans>
                : <Trans>See {inactive.length} new activities</Trans>
            }
          </p>
        </div>
      )}
    </>
  );
};

export default StoryTrendNotification;
